let clientId = window.ini.DEFAULT_CLIENT_ID ?? "2";
let hostname = window.location.hostname;

if (window.ini.CLIENTS) {
  clientId = window.ini.CLIENTS[hostname?.toLowerCase?.()] ?? clientId;
}

export { clientId };
